import React from 'react';
import './BookClubCard.css';
import GradientButton from '../ui/GradientButton/GradientButton';

interface BookClubCardProps {
  author: string;
  date: string;
  title: string;
  description: string;
  imageSrc: string;
}

const BookClubCard: React.FC<BookClubCardProps> = ({ author, date, title, description, imageSrc }) => {
  return (
    <div className="book-club-card">
      <div className="image-container">
        <img src={imageSrc} alt={title} />
      </div>
      <div className="card-content">
        <p className="author">Author: {author}</p>
        <p className="date">{date}</p>
        <h2 className="title">{title}</h2>
        <p className="description">{description}</p> 
        <GradientButton> Join Book Club</GradientButton>
      </div>
    </div>
  );
};

export default BookClubCard; /* BookClubCard.css */

